import ConsultationNoteController from '../consultation_note_controller'

export default class extends ConsultationNoteController {

  static targets = this.targets.concat([
    'dataSharingConsentPhotoSection',
    'procedureConsentPhotoSection',
    'patientDeclinedWarning'
  ])

  initialize() {
    super.initialize()
  }

  // ==== Controllers

  // ==== Actions

  showDataSharingConsentPhotoSection(event) {
    this.dataSharingConsentPhotoSectionTarget.hidden = event.target.value === 'false'
  }

  showProcedureConsentPhotoSection(event) {
    this.procedureConsentPhotoSectionTarget.hidden = event.target.value === 'false'
  }

  patientDeclined({ currentTarget: { checked }, params: { consentType } }) {
    this.patientDeclinedWarningTargets.find((t) => t.dataset.consentType === consentType)
      ?.classList.toggle('u-hide', !checked)
  }

  // ==== Getters

  // ==== Setters

  // ==== Private

  // ==== Channels

  // ==== Callbacks

}
